import { AliasType, UserGroup } from '../gql/graphql';

import { getPaginatedNodes } from './utils';
import { graphql } from '../gql';
import { useQuery } from '@apollo/client';

export const GET_ENTITIES_BROKERAGE_LIST = graphql(`
  query getBrokerageOptionsList(
    $sort: PaginationSort
    $pagination: PaginationRequest
  ) {
    entities(
      sort: $sort
      pagination: $pagination
      filters: { agency: true, depthSearch: 1, status: ACTIVE }
    ) {
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          uuid
          referenceId

          aliases(filters: { source: PRIMARY }) {
            edges {
              node {
                name
                type
              }
            }
          }

          users {
            edges {
              cursor
              node {
                uuid
                username
                userId
                groups
                type
              }
            }
          }
        }
      }
    }
  }
`);

export function useGetBrokerageOptionsList() {
  const { loading, error, data } = useQuery(GET_ENTITIES_BROKERAGE_LIST, {
    variables: {
      pagination: { first: 100000 },
    },
  });

  const parentData = data?.entities.edges.map((edge) => {
    const parent = edge?.node;
    const alias = getPaginatedNodes(parent?.aliases);
    const brokerageName = alias.filter((alias) => {
      return alias.type === AliasType.LegalName;
    })[0]?.name;

    return {
      name: brokerageName,
      value: parent.uuid,
      data: edge?.node?.users?.edges?.find(
        (user) => user?.node?.type === UserGroup.Bdm
      ),
      underwriterData: edge?.node?.users?.edges?.find(
        (user) => user?.node?.type === UserGroup.Underwriter
      ),
    };
  });

  return {
    error,
    loading,
    data,
    parentData,
  };
}
